import * as Constants from './Constants';

const initialState = {
  marketDetails: [],
  SSN: null,
  dateOfBirth: null,
  pin: null,
  pinConf: null,
  creditReviewSuccess: false,
  creditResponse: false,
  d2dEidResponse: null,
  creditCheckData: null,
  creditCheckFail: [],
  creditCheckAddressFail: false,
  eidSubmitResponse: false,
  showCreditCheckError: false,
  creditCheckServiceDetails: null,
  showZipcodeError: false,
  ccInvalidCaseError: false,
  creditCheckError: false,
  creditCheckNtfyMsg: null,
};

function creditCheckDetails(state = initialState, action) {
  // debugger;
  switch (action.type) {
    case Constants.GET_ZIP_DETAILS_SUCCESS:
      return { ...state, marketDetails: action.response && action.response };
    case 'RUN_CREDIT_REVIEW_SUCCESS_RESPONSE': {
      const previousState = state.creditResponse;
      return { ...state, creditReviewSuccessResponse: action.response && action.response, creditResponse: !previousState };
    }
    case Constants.RUN_CREDIT_REVIEW_SUCCESS:
      return { ...state, creditReviewSuccess: action.response && action.response };
    case 'FETCH_SSN':
      return { ...state, SSN: action.response.SSN, originalSSN: action.response.originalSSN };
    case 'FETCH_CONF_SSN':
      return { ...state, ...action.response };
    case 'FETCH_CONF_PIN':
      return { ...state, pinConf: action.response.pinConf, originalPinConf: action.response.originalPinConf };
    case 'FETCH_DATEOFBIRTH':
      return { ...state, dateOfBirth: action.response.dateOfBirth };
    case Constants.RUN_CREDIT_REVIEW_SUCCESS_DATA:
      return { ...state, creditReviewSuccessData: action.response && action.response };
    case 'FETCH_LOGIN_PIN':
      return { ...state, pin: action.response.pin };
    case 'CREDIT_CHECK_DATA':
      return { ...state, creditCheckData: action.response };
    case Constants.D2D_EID_SEND_MESSAGE_RESPONSE:
      return { ...state, d2dEidResponse: action.response };
    case 'INITIATE_CREDIT_FAILED_ADDRESS':
      return { ...state, creditCheckAddressFail: action.response };
    case 'INITIATE_CREDIT_FAILED_RLOAD':
      return { ...state, creditCheckAddressFail: false };
    case Constants.INITIATE_CREDIT_FAILED:
      return { ...state, creditCheckFail: action.response };
    case 'EID_DATA_SUBMIT_SUCCESS_RESPONSE': {
      const previousState = state.eidSubmitResponse;
      return { ...state, EidSubmitResponse: action.response, eidSubmitResponse: !previousState };
    }
    case 'CREDIT_CHECK_API_FAIL':
      return { ...state, showCreditCheckError: action.response, creditCheckServiceDetails: action.serviceinfo };
    case 'CREDIT_CHECK_API_CLEAR':
      return { ...state, showCreditCheckError: action.response };
    case 'CLEAR_CREDIT_CHECK_RESPONSE':
      return { ...state, creditReviewSuccessResponse: {} };
    case 'ERR_OCCURED':
      return { ...state, showZipcodeError: action.response };
    case Constants.CC_INVALIDCASE_ERROR:
      return { ...state, ccInvalidCaseError: action.response };
    case 'CEF_CREDIT_CHECK_ERROR':
      return { ...state, creditCheckError: action.response, creditCheckNtfyMsg: action.errorMessage };
    default:
      return state;
  }
}

export default creditCheckDetails;
